export default __webpack_public_path__ + "static/media/Chat.7ca1e0e6.png";